exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".room-card[data-v-0a1356ab]{height:100%;border-radius:8px;border:1px solid #eee;-webkit-transition:all .2s ease-in-out;transition:all .2s ease-in-out}.room-card[data-v-0a1356ab]:hover{border-color:#1976d2;-webkit-box-shadow:0 4px 12px rgba(25,118,210,.15)!important;box-shadow:0 4px 12px rgba(25,118,210,.15)!important}", ""]);

// exports
